import React from 'react';
import { Mail, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      background: 'rgba(0, 0, 0, 0.9)',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      padding: '3rem 0 2rem',
      marginTop: '4rem'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 2rem'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem',
          marginBottom: '2rem'
        }}>
          {/* Contact Info */}
          <div>
            <h3 style={{color: '#ff0080', marginBottom: '1rem'}}>Contact</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
              <a 
                href="mailto:info@vibrate.la" 
                style={{
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '0.5rem',
                  color: 'white',
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseOver={e => e.target.style.color = '#ff0080'}
                onMouseOut={e => e.target.style.color = 'white'}
              >
                <Mail size={18} />
                info@vibrate.la
              </a>
              <a 
                href="https://instagram.com/vibrate.la" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '0.5rem',
                  color: 'white',
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseOver={e => e.target.style.color = '#ff0080'}
                onMouseOut={e => e.target.style.color = 'white'}
              >
                <Instagram size={18} />
                @vibrate.la
              </a>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div style={{
          textAlign: 'center',
          paddingTop: '2rem',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          color: '#9ca3af'
        }}>
          <p>© {currentYear} Vibrate. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
